import React, { useEffect, useState } from 'react';

// Libs
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import Button from '@habitech/ui-button';

// CMS components
import { CMSNavbarMenu } from '@habitech/cms-navbar-menu';

// Icons
import IconArrow from 'templates/assets/icon-arrow.svg';
import Iconic from 'plugins/iconic/iconic';

// Services
import { getProjectData } from 'services';
import { getCountry } from 'utils';
import store from '../redux/store';
import HabiLogo from '../components/global/HabiLogo';
import Cookies from '../components/global/Cookies/Cookies';

function LayoutContent({ children }) {
  const { menu, cookie } = getProjectData();
  const [load, setLoad] = useState(true);
  const [urlAditionaCta, setUrlAditionalCta] = useState('');

  const findAditionalCta = (links) => {
    const reg = /\/business-tracker\/login/;
    const linkLogin = links.find((e) => reg.test(e?.route));
    if (urlAditionaCta?.length < 1) {
      setUrlAditionalCta(linkLogin?.route);
    }
    return linkLogin?.extra_data?.show_hero_button;
  };

  useEffect(() => {
    setLoad(false);
  }, []);

  const renderNavbarMenu = () => {
    const menus = {
      CO: (
        <CMSNavbarMenu
          navbar={{
            renderLogo: () => <HabiLogo size='S' dataId='Menu-Logo' />,
            links: menu.navBar.links,
          }}
          menu={{
            renderLogo: () => <HabiLogo size='M' dataId='Menu-Logo' />,
            links: menu.navBar.menu.menu_link,
          }}
          aditionalCta={{
            type: 'secondaryButton',
            text: 'Progreso de mi solicitud',
            url: urlAditionaCta ?? '/business-tracker/login',
            show: findAditionalCta(menu.navBar.menu.menu_link),
          }}
          renderAfterMenuBtn={() => (
            <div id='cta-hero-desktop-navbar' className='btn-cta-wrapper '>
              <Button
                dataId='cta-hero-desktop-navbar'
                onClick={() => window?.scrollTo(0, 0)}
                disabled={false}
                fluid
                type='submit'
                size='medium'
              >
                <span className='btn-cta-title'>Solicitar oferta</span>
                <IconArrow
                  className='btn-cta-title-arrow'
                  alt='Icono de flecha'
                  title='Icono de flecha'
                />
              </Button>
            </div>
          )}
          countries={[
            {
              label: 'COL',
              href: '/',
            },
            {
              label: 'MX',
              href: 'https://tuhabi.mx/',
            },
          ]}
          idAppElement='#___gatsby'
          withAnimation
        />
      ),
      MX: (
        <CMSNavbarMenu
          countries={[
            {
              label: 'MX',
              href: '/',
            },
            {
              label: 'COL',
              href: 'https://habi.co/',
            },
          ]}
          navbar={{
            renderLogo: () => <Iconic className='navbar-icon' name='tuhabi' />,
            links: menu.navBar.links,
          }}
          menu={{
            renderLogo: () => (
              <Iconic style={{ fontSize: '56px' }} name='tuhabi' />
            ),
            links: menu.navBar.menu.menu_link,
          }}
          aditionalCta={{
            type: 'secondaryButton',
            text: 'Progreso de mi solicitud',
            url: urlAditionaCta ?? '/business-tracker/login',
            show: findAditionalCta(menu.navBar.menu.menu_link),
          }}
          renderAfterMenuBtn={() => (
            <div id='cta-hero-desktop-navbar' className='btn-cta-wrapper '>
              <a
                className='ctaBtn navbar-cta'
                href='/formulario-inmueble/inicio'
                aria-labelledby='habi_services'
                target='_self'
                title='Ir a registrarse'
                data-id='cta-hero-desktop-navbar'
                id='cta-float'
              >
                <span className='btn-cta-title'>Solicitar oferta</span>
                <IconArrow
                  className='btn-cta-title-arrow'
                  alt='Icono de flecha'
                  title='Icono de flecha'
                />
              </a>
            </div>
          )}
          idAppElement='#___gatsby'
          withAnimation
        />
      ),
    };

    return menus[getCountry()] || null;
  };

  return (
    <div id='layout-gatsby'>
      <Provider store={store}>
        <section>
          {!load ? (
            <>
              <Cookies description={cookie} />
              {renderNavbarMenu()}
            </>
          ) : (
            <section className='menu-wrapper container-habi grid-layout'>
              <div className='skeleton-navbar'>
                <div className='skeleton-icon-habi sk-animation' />
                <div className='skeleton-menu-wrapper'>
                  <div className='skeleton-menu sk-animation' />
                  <div className='skeleton-menu sk-animation' />
                  <div className='skeleton-menu sk-animation' />
                </div>
              </div>
            </section>
          )}
          {children}
        </section>
      </Provider>
    </div>
  );
}

LayoutContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutContent;
